import { render } from "./ToDoView.vue?vue&type=template&id=0deecf60&ts=true"
import script from "./ToDoView.vue?vue&type=script&lang=ts"
export * from "./ToDoView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__